import { styled, css } from '@mui/system'
import { bool, shape } from 'prop-types'
import Image from './image'
import { Parallax } from 'react-scroll-parallax'
import reactScrollParallaxPropTypes from '../react-scroll-parallax/prop-types'

const shouldForwardProp = (prop) => !['aboveTheFold'].includes(prop)

const Div = styled('div', { shouldForwardProp })``

const Root = styled(Div)`
	position: relative;
	overflow: hidden;
	z-index: 0;
	width: ${({ aboveTheFold }) => (aboveTheFold ? '100%' : undefined)};
	height: ${({ aboveTheFold }) => (aboveTheFold ? '100%' : undefined)};
	${({ ['data-bhhide']: hide }) => (hide ? 'display: none !important;' : '')}
`
const bgStyle = css`
	overflow: hidden;
	height: 100%;
	width: 100%;
	z-index: -1;
	position: absolute;
	top: 0;
	left: 0;
`
const Background = styled('div')`
	${bgStyle}
`

const BackgroundParallax = styled(Parallax)`
	${bgStyle}
`

const ResolveWarning = styled('div')`
	width: 100%;
	height: 100%;
`

const ImageBackground = ({
	aboveTheFold,
	alt,
	breakpoint,
	children,
	crop,
	format,
	gravity,
	height,
	hide,
	layout,
	loader,
	objectFit,
	objectPosition,
	onLoadingComplete,
	originalHeight,
	originalWidth,
	placeholder,
	quality,
	reactScrollParallaxConfig,
	rotate,
	sharpen,
	spinnerPlaceholder,
	src,
	unoptimized,
	width,
	loading,
	priority,
	...props
}) => {
	const BackgroundComponent = reactScrollParallaxConfig?.disabled ? Background : BackgroundParallax
	return (
		<Root data-bhhide={hide} data-bhbreakpoint={breakpoint} aboveTheFold={aboveTheFold} {...props}>
			{src && (
				<BackgroundComponent {...(reactScrollParallaxConfig?.disabled ? {} : reactScrollParallaxConfig)}>
					{/* This div resolve warning `Image with src "${src}" may not render properly with a parent using position:"${parent.position}". Consider changing the parent style to position:"relative" with a width and height.` */}
					<ResolveWarning>
						{/* eslint-disable-next-line jsx-a11y/alt-text */}
						<Image
							alt={alt}
							background
							crop={crop}
							format={format}
							gravity={gravity}
							height={height}
							layout={layout}
							loader={loader}
							objectFit={objectFit}
							objectPosition={objectPosition}
							onLoadingComplete={onLoadingComplete}
							originalHeight={originalHeight}
							originalWidth={originalWidth}
							placeholder={placeholder}
							quality={quality}
							rotate={rotate}
							sharpen={sharpen}
							spinnerPlaceholder={spinnerPlaceholder}
							src={src}
							unoptimized={unoptimized}
							width={width}
							loading={loading}
							priority={priority}
						/>
					</ResolveWarning>
				</BackgroundComponent>
			)}
			{children}
		</Root>
	)
}

ImageBackground.defaultProps = {
	hide: false,
	objectFit: 'cover',
	objectPosition: 'center',
	reactScrollParallaxConfig: {
		disabled: true,
	},
}

ImageBackground.propTypes = {
	imageProps: shape(Image.propTypes),
	reactScrollParallaxConfig: shape(reactScrollParallaxPropTypes),
	hide: bool,
}

export default ImageBackground
